import { NAVIGATION_CONFIG } from '../config/navigation.config';
import { NavigationConfig } from '../types/navigation.types';

/**
 * Find the best accessible route for a user based on their permissions
 * Prioritizes dashboard, then falls back to first accessible menu item
 * Used after organization switching to redirect to an appropriate page
 */
export function getFirstAccessibleRoute(permissions: string[]): string {
  // Helper to check if user has required permission
  const hasPermission = (required: string | string[] | undefined): boolean => {
    if (!required) return true;
    
    // Wildcard permission grants all access
    if (permissions.includes('*.*')) return true;
    
    if (Array.isArray(required)) {
      // User needs ANY of the permissions
      return required.some(p => permissions.includes(p));
    }
    
    return permissions.includes(required);
  };

  // First, check if dashboard is accessible
  const dashboardAccessible = hasPermission(undefined); // Dashboard typically has no specific permission requirement
  if (dashboardAccessible) {
    return '/dashboard';
  }

  // If dashboard not accessible, find first accessible route from navigation
  const findRoute = (items: NavigationConfig[]): string | null => {
    for (const item of items) {
      // Check if this item has a path and user has permission
      if (item.path && hasPermission(item.requiredPermission)) {
        return item.path;
      }
      
      // Check children
      if (item.children) {
        const childRoute = findRoute(item.children);
        if (childRoute) return childRoute;
      }
    }
    return null;
  };

  const route = findRoute(NAVIGATION_CONFIG);
  
  // Final fallback to dashboard
  return route || '/dashboard';
}

// Made with Bob